import { isSameDay, startOfDay } from "date-fns";
import * as z from "zod";
import { APPOINTMENT_CALENDAR_STATUS_VALUES } from "@/constants/appointments/appointments-constants";
import { requiredErrorMessage } from "../common/error-messages";
import { appointmentServiceLineSchema } from "./add-appointment-schema";

export const editAppointmentSchema = (originalDate: Date, today: Date) =>
  z.object({
    client_id: z.number().min(1, requiredErrorMessage),
    appointment_date: z.date().refine(
      (date) =>
        startOfDay(date) >= today || isSameDay(date, originalDate),
      { message: requiredErrorMessage }
    ),
    status: z.enum(APPOINTMENT_CALENDAR_STATUS_VALUES),
    services: z.array(appointmentServiceLineSchema).min(1),
  });

export type EditAppointmentFormValues = z.infer<
  ReturnType<typeof editAppointmentSchema>
>;
